import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonios() {
  const testimonios = [{
    name: 'Lic. Mariana G.',
    city: 'Buenos Aires',
    text: 'Antes de este kit, mi agenda era un caos y no sabía cuánto iba a cobrar a fin de mes. La calculadora de ingresos me abrió los ojos. Lo recomiendo 100%.',
    initials: 'MG',
    color: 'bg-blue-100 text-blue-700'
  }, {
    name: 'Lic. Florencia R.',
    city: 'Córdoba',
    text: 'La política de cancelación me salvó. Siempre me daba cosa cobrar las sesiones que me cancelaban sobre la hora. Ahora tengo una regla clara y los pacientes la respetan.',
    initials: 'FR',
    color: 'bg-purple-100 text-purple-700'
  }, {
    name: 'Lic. Julieta M.',
    city: 'Rosario',
    text: 'Es exactamente lo que no te enseñan en la facultad. Empecé a aplicar los mensajes para cobrar y me saqué un peso de encima enorme. Muy práctico.',
    initials: 'JM',
    color: 'bg-green-100 text-green-700'
  }, {
    name: 'Lic. Carolina S.',
    city: 'Mendoza',
    text: 'Me di cuenta de que estaba perdiendo mucha plata por no tener un sistema. El kit se paga solo con la primera sesión que no te cancelan. Excelente inversión.',
    initials: 'CS',
    color: 'bg-orange-100 text-orange-700'
  }, {
    name: 'Lic. Paula V.',
    city: 'La Plata',
    text: 'Súper claro y directo al grano. Nada de teoría aburrida, son herramientas que copiás y usás en el día. Me ordenó muchísimo el consultorio.',
    initials: 'PV',
    color: 'bg-pink-100 text-pink-700'
  }];
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-170">
      <div className="max-w-6xl mx-auto" data-id="element-171">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-172">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0f4c5c] mb-4" data-id="element-173">
            Colegas que ya ordenaron su consultorio
          </h2>
          <div className="flex justify-center gap-1 mb-2" data-id="element-174">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-[#d4a017] text-[#d4a017]" data-id="element-175" />)}
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-176">
          {testimonios.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-slate-50 rounded-2xl p-6 border border-slate-100 shadow-sm" data-id="element-177">
              <div className="flex items-center gap-4 mb-4" data-id="element-178">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg ${t.color}`} data-id="element-179">
                  {t.initials}
                </div>
                <div data-id="element-180">
                  <p className="font-bold text-slate-800" data-id="element-181">{t.name}</p>
                  <p className="text-sm text-slate-500" data-id="element-182">{t.city}</p>
                </div>
              </div>
              <p className="text-slate-700 italic" data-id="element-183">"{t.text}"</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}